// extracted by mini-css-extract-plugin
export default {"root":"UploadInput__root--zTCNd","input":"UploadInput__input--uhga3"};